var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.3633C2 4.1226 3.81644 2.30615 6.05714 2.30615H17.9429C20.1836 2.30615 22 4.1226 22 6.3633V18.249C22 20.4897 20.1836 22.3062 17.9429 22.3062H6.05714C3.81645 22.3062 2 20.4897 2 18.249V6.3633ZM6.05714 4.02044C4.76322 4.02044 3.71429 5.06937 3.71429 6.3633V18.249C3.71429 19.5429 4.76322 20.5919 6.05714 20.5919H17.9429C19.2368 20.5919 20.2857 19.5429 20.2857 18.249V6.3633C20.2857 5.06937 19.2368 4.02044 17.9429 4.02044H6.05714Z",
    fill: "#8F99D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08175 1C8.55514 1 8.93889 1.38376 8.93889 1.85714V4.46939C8.93889 4.94278 8.55514 5.32653 8.08175 5.32653C7.60837 5.32653 7.22461 4.94278 7.22461 4.46939V1.85714C7.22461 1.38376 7.60837 1 8.08175 1Z",
    fill: "#8F99D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9184 1C16.3918 1 16.7756 1.38376 16.7756 1.85714V4.46939C16.7756 4.94278 16.3918 5.32653 15.9184 5.32653C15.445 5.32653 15.0613 4.94278 15.0613 4.46939V1.85714C15.0613 1.38376 15.445 1 15.9184 1Z",
    fill: "#8F99D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71429 11C3.71429 14.494 6.54678 17.3265 10.0408 17.3265H20.4898C20.9632 17.3265 21.3469 17.7103 21.3469 18.1837C21.3469 18.6571 20.9632 19.0408 20.4898 19.0408H10.0408C5.60001 19.0408 2 15.4408 2 11H3.71429Z",
    fill: "#8F99D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57104 8.79599C6.57104 8.3226 6.9548 7.93884 7.42819 7.93884H7.99962C8.473 7.93884 8.85676 8.3226 8.85676 8.79599C8.85676 9.26937 8.473 9.65313 7.99962 9.65313H7.42819C6.9548 9.65313 6.57104 9.26937 6.57104 8.79599Z",
    fill: "#8F99D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1431 8.79599C11.1431 8.3226 11.5268 7.93884 12.0002 7.93884H12.5716C13.045 7.93884 13.4288 8.3226 13.4288 8.79599C13.4288 9.26937 13.045 9.65313 12.5716 9.65313H12.0002C11.5268 9.65313 11.1431 9.26937 11.1431 8.79599Z",
    fill: "#8F99D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7146 8.79599C15.7146 8.3226 16.0984 7.93884 16.5717 7.93884H17.1432C17.6166 7.93884 18.0003 8.3226 18.0003 8.79599C18.0003 9.26937 17.6166 9.65313 17.1432 9.65313H16.5717C16.0984 9.65313 15.7146 9.26937 15.7146 8.79599Z",
    fill: "#8F99D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57104 13.3674C6.57104 12.894 6.9548 12.5103 7.42819 12.5103H7.99962C8.473 12.5103 8.85676 12.894 8.85676 13.3674C8.85676 13.8408 8.473 14.2245 7.99962 14.2245H7.42819C6.9548 14.2245 6.57104 13.8408 6.57104 13.3674Z",
    fill: "#8F99D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1431 13.3674C11.1431 12.894 11.5268 12.5103 12.0002 12.5103H12.5716C13.045 12.5103 13.4288 12.894 13.4288 13.3674C13.4288 13.8408 13.045 14.2245 12.5716 14.2245H12.0002C11.5268 14.2245 11.1431 13.8408 11.1431 13.3674Z",
    fill: "#8F99D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7146 13.3674C15.7146 12.894 16.0984 12.5103 16.5717 12.5103H17.1432C17.6166 12.5103 18.0003 12.894 18.0003 13.3674C18.0003 13.8408 17.6166 14.2245 17.1432 14.2245H16.5717C16.0984 14.2245 15.7146 13.8408 15.7146 13.3674Z",
    fill: "#8F99D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.03bae4fa.svg";
export { ForwardRef as ReactComponent };